import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {msg} from '@lit/localize';
import {FeatureSelect} from './featureSelect';

import info from '../../../icons/info';
import {staggeredReveal} from '../../css/styleSets';
import {pimText} from '../../util/values';
import {selectSolarLuminarCountValue} from '../../solar/solarSelectors';

@customElement('feature-compact-select')
export class FeatureCompactSelect extends FeatureSelect {

	static styles = [
		staggeredReveal,
		css`
			:host {
			}

			.title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				font: var(--font-widget-title);
				color: var(--color-widget-text);
				margin-bottom: 12px;
			}

			.info {
				color: var(--color-widget-infoicon);
				background-color: transparent;
				cursor: pointer;
				transition: background-color 0.4s, color 0.4s;
				border: none;
				padding: 0;
			}
			.info:hover {
				color: var(--color-widget-text);
			}
			.info svg path {
				fill: currentColor;
				stroke: currentColor;
			}
			.info svg circle {
				stroke: currentColor;
			}

			.values {
				display: flex;
				flex-flow: wrap;
			}


			.values.notSatisfied {
				border-left-color: var(--color-warn);
			}

			.satisfied {
				color: var(--color-text-widget-title);
			}

			.notSatisfied {
				color: var(--color-warn);
			}
        `];


	render() {
		// if (this.canBeOmitted()) return null;
		// TODO: remove dirty Hack for Aeto
		let title = pimText(this.lang, this.feature.variableId, 'F', this.decisions, this.translations);
		if (this.state.status.family === 'Aeto') {
			if (selectSolarLuminarCountValue(this.state) === 1 && this.feature.variableId === 'LE_LuminairePositionHeightSU_2') return null;

			if (this.feature.variableId === 'LE_LuminairePositionHeightSU_1') {
				title = msg('Light point height (over base pole)') + ' 1';
			}
			if (this.feature.variableId === 'LE_LuminairePositionHeightSU_2') {
				title = msg('Light point height (over base pole)') + ' 2';
			}
			if (this.feature.variableId === 'LE_LightDistribution_1') {
				title = msg('Light distribution') + ' 1';
			}
			if (this.feature.variableId === 'LE_LightDistribution_2') {
				title = msg('Light distribution') + ' 2';
			}
		}
		if (title === '') { title = this.feature.variableId;}

		return html`
			<div>
				<div class="title">
					${title}
					${when(this.hasFeatureDescription(), () => html`
						<button class="info" @click="${this.openModal}">
							${info}
						</button>
					`)}
				</div>
				<div class="values ${classMap({highlight: this.isHighlight(), notSatisfied: !this.isSatisfied()})}">
					${repeat([...this.feature.values]
									// .filter(value => !value.disabled)
									.sort((a, b) => this.getProductData(a.featureValueId)?.displaySequenceUi - this.getProductData(b.featureValueId)?.displaySequenceUi),
							(featureValue) => featureValue.featureValueId,
							(featureValue) => html`
								<feature-compact-select-item
									.feature=${this.feature}
									.hideDisabled=${this.hideDisabled}
									.featureValue=${featureValue}
									.productData=${this.getProductData(featureValue.featureValueId)}>
								</feature-compact-select-item>
							`)}
				</div>
			</div>

		`;
	}
}
